var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.6,366.4v-25c0-14.3-10.6-26-24.4-28V252c0-20.2-16.4-36.6-36.6-36.6C18.4,215.4,2,231.8,2,252v153.7l73.2,73.2V508    h16.3v-35.9L18.3,399V252c0-11.2,9.1-20.3,20.3-20.3c11.2,0,20.3,9.1,20.3,20.3v63.8c-9.6,4.6-16.3,14.3-16.3,25.6V378h16.3v-36.6    c0-6.7,5.5-12.2,12.2-12.2c6.7,0,12.2,5.5,12.2,12.2v31.8l56.9,56.9V508h16.3v-84.7L99.6,366.4z",
    fill: "#20d34a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.4,215.4c-20.2,0-36.6,16.4-36.6,36.6v61.4c-13.8,2-24.4,13.7-24.4,28v25.1l-56.9,56.9V508h16.3v-77.9l56.9-56.9    v-31.8c0-6.7,5.5-12.2,12.2-12.2s12.2,5.5,12.2,12.2V378h16.3v-36.6c0-11.3-6.7-21-16.3-25.6V252c0-11.2,9.1-20.3,20.3-20.3    c11.2,0,20.3,9.1,20.3,20.3v147l-73.2,73.2V508h16.3v-29.1l73.2-73.2V252C506,231.8,489.6,215.4,469.4,215.4z",
    fill: "#20d34a"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254,0c0,0-130.1,142.8-130.1,215.4c0,71.7,58.3,130.1,130.1,130.1s130.1-58.3,130.1-130.1C384.1,142.3,254,0,254,0z     M254,329.2c-62.7,0-113.8-51.1-113.8-113.8c0-55.1,89.4-162.6,113.8-190.9c24.4,28.3,113.8,135.8,113.8,190.9    C367.8,278.1,316.7,329.2,254,329.2z",
    fill: "#20d34a"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.8,215.4h-16.3c0,49.3,40.1,89.4,89.4,89.4v-16.3C213.7,288.5,180.8,255.7,180.8,215.4z",
    fill: "#20d34a"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 386.1,
    width: 16.3,
    height: 16.3,
    fill: "#20d34a"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.4,
    y: 386.1,
    width: 16.3,
    height: 16.3,
    fill: "#20d34a"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 386.1,
    width: 16.3,
    height: 16.3,
    fill: "#20d34a"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service_1.f2ed0c004b15a7ca90db017e9eead9eb.svg";
export { ForwardRef as ReactComponent };